import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import withDealerPermission from './dealerPermission';

function DeleteButton({ dealer, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(dealer.id)}
      body={`Are you sure you want to delete ${dealer.name}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${dealer.name}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  dealer: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withDealerPermission(Permissions.DELETE)(DeleteButton);
